<template>
    <table :class="tableClass">
        <thead :class="titleColor">
        <tr>
            <th>{{ title }}</th>
            <th class="number">Anzahl</th>
            <th class="number">Anteil</th>
        </tr>
        </thead>
        <tbody class="no-border-x">
        <tr v-for="(row,k) in rows" :key="k">
            <td>{{ row.value }}</td>
            <td class="number">{{ row.result }}</td>
            <td class="number">{{ Math.round((100 / row.total) * row.result) }}%</td>
        </tr>
        </tbody>
    </table>
</template>

<script>
    export default {
        props: {
            border: Boolean,
            title: String,
            titleColor: String,
            rows: Array,
        },

        computed: {
            tableClass() {
                return {
                    'table table-sm table-striped': true,
                    'table-bordered': this.border,
                };
            },
        },
    };
</script>
